import { NFC_SERVICE_URL, NFC_WS_STATUS } from "@/constants";
import { cn } from "@/libs/cn";
import { useNFCStore } from "@/states/zustand/nfc";
import { useNotificationStore } from "@/states/zustand/notification";
import { Button, Divider, Flex } from "antd";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { AiFillFileText } from "react-icons/ai";
import { Link } from "react-router";
import { AnimatedComponent, PageTitle } from "../common";
import { NFCReader } from "../Settings/NFC";

export function Attendance() {
	const { reader_status } = useNFCStore();
	const { setNotification } = useNotificationStore();

	useEffect(() => {
		let ws: WebSocket;
		let reconnectInterval: NodeJS.Timeout;

		const connect = () => {
			ws = new WebSocket(NFC_SERVICE_URL);
			const store = useNFCStore.getState();
			// checking whether the reader is connected or not.
			if (ws) store.setWS(ws);

			ws.onopen = () => {
				ws.send(
					JSON.stringify({ type: NFC_WS_STATUS.GET_READER_STATUS }),
				);
			};

			ws.onmessage = (msgEvent) => {
				const data = JSON.parse(msgEvent.data);
				switch (data.type) {
					case NFC_WS_STATUS.READER_STATUS:
						setNotification({
							type: data?.success ? "success" : "error",
							message: data?.success
								? "Reader connected!"
								: "Reader disconnected!",
						});
						store.setReaderStatus(data.success);
						break;
					case NFC_WS_STATUS.CARD_STATUS:
						store.setCardStatus(data.success);
						break;
					case NFC_WS_STATUS.DATA_READ_SUCCESS: {
						// getting the deep_link from the card: which record_type is 'U'
						const deep_link: NdefRecord = data?.data?.find(
							(it: NdefRecord) =>
								it.record_type.toLowerCase() === "u",
						);

						// deep_link format => telegram://conversations/chat/10 : we only need Id <10> from the link.
						const parts = deep_link?.payload.split("/");
						const user_id = parts[parts.length - 1];

						if (!parseInt(user_id)) {
							setNotification({
								type: "warning",
								message: "No usable data found!",
							});
							return;
						}

						store.setReadData(user_id);
						break;
					}
					case NFC_WS_STATUS.DATA_READ_ERROR:
						setNotification({
							type: "warning",
							message: data.error,
						});
						break;
					case NFC_WS_STATUS.READER_ERROR:
						console.log(data?.error);
						break;
					case NFC_WS_STATUS.DATA_WRITE_SUCCESS:
						setNotification({
							type: "success",
							message: data.message,
						});
						break;
					case NFC_WS_STATUS.DATA_WRITE_ERROR:
						setNotification({
							type: "error",
							message: data.error,
						});
						break;
					default:
						break;
				}
			};

			ws.onclose = () => {
				console.log("Disconnected. Trying to reconnect...");
				reconnectInterval = setTimeout(connect, 2000);
			};
		};

		connect();

		return () => {
			if (ws) ws.close();
			if (reconnectInterval) clearInterval(reconnectInterval);
		};
	}, []);
	return (
		<AnimatedComponent>
			<Helmet>
				<title> Attendance </title>
			</Helmet>
			<div className="flex items-center justify-between">
				<PageTitle>Attendance</PageTitle>
				<Link to={"meditation-retreats"}>
					<Button
						type="primary"
						className="bg-primary-gradient"
						size="large"
						icon={<AiFillFileText size={16} />}
						shape="circle"
					/>
				</Link>
			</div>
			<Divider />
			<Flex align="center" gap={8} className="!mb-6">
				<div
					className={cn(
						"w-4 h-4 aspect-square rounded-full bg-danger",
						{
							"bg-success": reader_status,
						},
					)}
				/>
				<p className="font-poppins text-base">
					NFC Reader {reader_status ? "Connected" : "Disconnected"}!
				</p>
			</Flex>
			<NFCReader isInAttendanceComp={true} />
		</AnimatedComponent>
	);
}
